var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArkanLogoSectiom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 98,
    viewBox: "0 0 82 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3379 18.2812L38.3359 18.2568L36.9492 4.16016C36.9495 3.58571 36.961 2.85452 37.2432 2.2627C37.3799 1.97587 37.577 1.73254 37.8662 1.55664C38.1574 1.37959 38.5768 1.25 39.1914 1.25C39.8009 1.25004 40.2165 1.3791 40.5049 1.55566C40.7915 1.73115 40.987 1.97457 41.123 2.26172C41.405 2.85705 41.4139 3.59325 41.4141 4.16895L40.0293 18.2568L40.0264 18.2812V18.3057C40.0263 18.5431 39.9495 19.2032 39.8223 20.1113C39.6977 21.0007 39.532 22.0843 39.3652 23.1348C39.3063 23.5059 39.2446 23.8722 39.1875 24.2246C39.1296 23.8719 39.0676 23.5052 39.0078 23.1338C38.8388 22.0833 38.6711 20.9997 38.5449 20.1104C38.416 19.202 38.3379 18.5425 38.3379 18.3057V18.2812Z",
    fill: "url(#paint0_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0791 3.56836C26.6581 3.35677 27.0969 3.33455 27.4307 3.40039C27.762 3.46583 28.0291 3.62642 28.2539 3.84766C28.7206 4.30711 28.9772 4.99305 29.1689 5.53125L32.7051 19.2656L32.7109 19.2881L32.7188 19.3086C32.7983 19.532 32.9496 20.18 33.1387 21.0762C33.3239 21.9541 33.5361 23.0285 33.7373 24.0723C33.808 24.4388 33.8743 24.8018 33.9404 25.1504C33.7663 24.8394 33.5835 24.5164 33.4014 24.1885C32.8845 23.2582 32.3574 22.2967 31.9365 21.5039C31.5062 20.6934 31.2102 20.1018 31.1318 19.8818L31.123 19.8564L31.1123 19.833L24.9814 7.05859C24.7885 6.51637 24.5487 5.82567 24.6094 5.17285C24.6387 4.85757 24.7376 4.56318 24.9463 4.30176C25.1564 4.03856 25.5032 3.7766 26.0771 3.56934L26.0791 3.56836Z",
    fill: "url(#paint1_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7686 9.60352C16.1015 9.55349 16.4084 9.61365 16.6973 9.74512C17.2937 10.0167 17.7743 10.5685 18.1377 11.0039L26.1543 22.6992L26.167 22.7188L26.1826 22.7373C26.3335 22.9186 26.6978 23.4738 27.1826 24.252C27.6577 25.0144 28.2255 25.9534 28.7725 26.8672C28.9659 27.1904 29.1541 27.5117 29.3369 27.8193C29.0653 27.5853 28.7812 27.343 28.4961 27.0957C27.6913 26.3977 26.8658 25.6744 26.1982 25.0732C25.516 24.4589 25.0344 24.0038 24.8848 23.8242L24.8691 23.8047L24.8506 23.7871L14.7217 13.8701C14.3563 13.4314 13.8976 12.8673 13.7344 12.2344C13.6554 11.9281 13.6493 11.6159 13.7568 11.2959C13.8651 10.9737 14.1007 10.6049 14.5674 10.21C15.0325 9.82078 15.4339 9.65386 15.7686 9.60352Z",
    fill: "url(#paint2_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85547 19.2324C8.50761 19.2837 9.14381 19.6366 9.64844 19.9209L21.166 28.1855L21.1885 28.2012L21.2119 28.2148C21.4166 28.3302 21.9488 28.7236 22.6729 29.2881C23.3809 29.8401 24.2357 30.526 25.0615 31.1963C25.3536 31.4333 25.6403 31.6704 25.917 31.8965C25.5822 31.7697 25.2329 31.6395 24.8809 31.5049C23.8872 31.1248 22.8659 30.7276 22.0342 30.3906C21.1831 30.0458 20.5773 29.7818 20.377 29.6631L20.3535 29.6494L20.3281 29.6377L7.4043 23.7891C6.91358 23.5069 6.29066 23.1329 5.9209 22.5947C5.74155 22.3336 5.62889 22.0421 5.62012 21.7041C5.61129 21.3638 5.70669 20.9366 6.00977 20.4062L6.00879 20.4053C6.31551 19.8765 6.63707 19.5806 6.93457 19.418C7.23066 19.2562 7.53925 19.2076 7.85547 19.2324Z",
    fill: "url(#paint3_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79688 32.2441C3.42853 32.0716 4.15189 32.1897 4.71875 32.29L18.3682 36.0938L18.3906 36.0996L18.415 36.1035C18.6487 36.145 19.2847 36.3361 20.1562 36.6201C21.0098 36.8983 22.047 37.2517 23.0518 37.5996C23.4087 37.7232 23.761 37.8484 24.0996 37.9668C23.7395 37.9623 23.3645 37.96 22.9854 37.9541C21.9217 37.9374 20.8265 37.9145 19.9307 37.8838C19.0147 37.8524 18.3555 37.8135 18.1279 37.7725L18.1025 37.7676L18.0771 37.7656L3.92676 36.6807C3.36286 36.5802 2.65015 36.4406 2.12207 36.0605C1.86593 35.8762 1.66218 35.6407 1.54102 35.3262C1.41901 35.0094 1.36685 34.5753 1.47461 33.9727V33.9697C1.57827 33.3677 1.77667 32.9804 1.99902 32.7275C2.21983 32.4765 2.49178 32.3275 2.79688 32.2441Z",
    fill: "url(#paint4_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8799 44.9707C21.9283 45.4476 20.9453 45.9345 20.1348 46.3223C19.3074 46.7181 18.7016 46.9909 18.4756 47.0625L18.4395 47.0732L18.4062 47.0898L10.5898 50.918C10.0437 51.0905 9.35162 51.2972 8.71094 51.208C8.39917 51.1646 8.11048 51.0517 7.8584 50.8311C7.60451 50.6088 7.35733 50.2503 7.17383 49.668C6.99031 49.0855 6.98778 48.6491 7.06836 48.3203C7.14836 47.994 7.31947 47.7349 7.5498 47.5195C8.02217 47.078 8.70508 46.8469 9.25 46.6738L17.8936 45.4707L17.9355 45.4648L17.9756 45.4521C18.2012 45.3807 18.8535 45.2544 19.7578 45.1025C20.643 44.9539 21.7258 44.7876 22.7773 44.6309C23.1466 44.5758 23.5121 44.5239 23.8633 44.4727C23.5451 44.6334 23.2152 44.8026 22.8799 44.9707Z",
    fill: "url(#paint5_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.668 51.3624C26.09 52.2549 25.4898 53.1713 24.9883 53.9161C24.4762 54.6767 24.0914 55.2199 23.9326 55.3976L23.9141 55.4191L23.8975 55.4425L18.1279 63.589C17.7462 64.0155 17.2499 64.5502 16.6465 64.799C16.3538 64.9196 16.0455 64.9678 15.7139 64.9044C15.38 64.8406 14.9831 64.656 14.5283 64.2452L14.5264 64.2433L14.3662 64.0919C14.0178 63.7439 13.8364 63.4235 13.752 63.1417C13.6562 62.8221 13.6733 62.5133 13.7637 62.2111C13.9497 61.589 14.426 61.042 14.8096 60.6124L22.625 54.3224L22.6572 54.297L22.6846 54.2657C22.8421 54.0895 23.3397 53.6512 24.042 53.0616C24.7295 52.4846 25.5783 51.7922 26.4053 51.1241C26.696 50.8893 26.9847 50.6589 27.2617 50.4366C27.0694 50.7357 26.8713 51.0484 26.668 51.3624Z",
    fill: "url(#paint6_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6699 55.0557C32.4687 56.0994 32.2565 57.1739 32.0713 58.0518C31.8822 58.9478 31.7299 59.5949 31.6504 59.8184L31.6455 59.833L31.6406 59.8486L26.3203 78.3867C26.1293 78.9224 25.8682 79.6098 25.3994 80.0693C25.1732 80.291 24.9057 80.4512 24.5752 80.5166C24.2423 80.5825 23.8057 80.56 23.2314 80.3486L23.2285 80.3477L23.0244 80.2676C22.57 80.0748 22.281 79.8442 22.0957 79.6133C21.8855 79.3513 21.7841 79.057 21.7539 78.7422C21.6913 78.0872 21.9348 77.3904 22.1348 76.8535L30.0498 59.2656L30.0576 59.2471L30.0645 59.2275C30.1428 59.0076 30.4379 58.4171 30.8682 57.6084C31.2891 56.8173 31.8171 55.8588 32.334 54.9307C32.5171 54.6019 32.7 54.2776 32.875 53.9658C32.8082 54.3179 32.7413 54.6852 32.6699 55.0557Z",
    fill: "url(#paint7_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3652 55.9766C39.532 57.027 39.6977 58.1106 39.8223 59C39.9495 59.9083 40.0264 60.5684 40.0264 60.8057V60.8164L40.0273 60.8262L41.415 94.332C41.415 94.9105 41.4073 95.6507 41.123 96.2471C40.9874 96.5314 40.7924 96.7731 40.5059 96.9473C40.2173 97.1225 39.8013 97.25 39.1914 97.25C38.576 97.25 38.1557 97.1223 37.8643 96.9463C37.5751 96.7716 37.3795 96.5293 37.2432 96.2451C36.9608 95.6564 36.9494 94.9279 36.9492 94.3525L38.3379 60.8262V60.8057C38.3379 60.569 38.416 59.9094 38.5449 59.001C38.6711 58.1116 38.8388 57.028 39.0078 55.9775C39.0676 55.6058 39.1296 55.2387 39.1875 54.8857C39.2446 55.2384 39.3063 55.6051 39.3652 55.9766Z",
    fill: "url(#paint8_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9717 54.9297C45.4874 55.8578 46.0146 56.8169 46.4365 57.6084C46.8671 58.4162 47.1674 59.0113 47.251 59.2354L47.2539 59.2451L47.2588 59.2549L58.9297 86.957H58.9307C59.1313 87.4952 59.3785 88.1965 59.3154 88.8555C59.2853 89.1703 59.1839 89.4645 58.9736 89.7266C58.762 89.9904 58.4149 90.2536 57.8408 90.4609L57.8379 90.4619C57.2635 90.6733 56.8282 90.6956 56.4971 90.6299C56.1683 90.5646 55.9021 90.4044 55.6768 90.1826C55.3222 89.8335 55.0866 89.3555 54.9053 88.9082L54.7402 88.4775L45.668 59.835L45.665 59.8271L45.6621 59.8184L45.5889 59.5742C45.5037 59.2559 45.383 58.7238 45.2412 58.0518C45.056 57.1739 44.8438 56.0994 44.6426 55.0557C44.5721 54.6899 44.5045 54.3274 44.4385 53.9795C44.6106 54.2871 44.7916 54.6057 44.9717 54.9297Z",
    fill: "url(#paint9_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8779 52.0225C50.6816 52.7183 51.5062 53.4394 52.1748 54.0391C52.8571 54.651 53.3432 55.1077 53.499 55.29L53.5088 55.3008L53.5186 55.3105L70.1416 72.6826C70.5157 73.1301 70.9766 73.6982 71.1396 74.3301C71.2185 74.6357 71.2239 74.9458 71.1152 75.2627C71.0057 75.5819 70.7677 75.9469 70.2969 76.3379L70.293 76.3408C69.8261 76.7358 69.4252 76.9068 69.0918 76.959C68.761 77.0106 68.457 76.9515 68.1699 76.8213C67.5702 76.5492 67.0887 75.992 66.7109 75.5498L52.2129 56.4082L52.207 56.4004L52.2012 56.3936C52.0481 56.2059 51.6825 55.6452 51.1982 54.8672C50.7231 54.1038 50.1553 53.1656 49.6084 52.2529C49.4158 51.9316 49.228 51.6125 49.0459 51.3066C49.3149 51.5381 49.5956 51.778 49.8779 52.0225Z",
    fill: "url(#paint10_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.501 47.623C54.4947 48.002 55.5165 48.3977 56.3486 48.7324C57.1985 49.0742 57.8076 49.3355 58.0107 49.4521L58.0186 49.457L58.0273 49.4609L76.2549 59.0449V59.0458C76.7552 59.3423 77.3913 59.7178 77.7676 60.2636C77.9468 60.5236 78.0595 60.8134 78.0684 61.1494C78.0772 61.4879 77.9809 61.9137 77.6777 62.4443C77.3708 62.9737 77.0506 63.2708 76.7529 63.4335C76.4568 63.5953 76.1483 63.644 75.832 63.6191C75.1768 63.5675 74.538 63.2107 74.0322 62.9257L57.2148 50.9443L57.1953 50.9306L57.1758 50.9189C56.9673 50.7976 56.432 50.3994 55.709 49.8349C55.0006 49.2818 54.1462 48.5959 53.3203 47.9267C53.0312 47.6924 52.7468 47.4588 52.4727 47.2353C52.8051 47.3609 53.1516 47.4897 53.501 47.623Z",
    fill: "url(#paint11_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3457 44.6689C78.9106 44.7694 79.628 44.9106 80.1611 45.293C80.4185 45.4776 80.6237 45.7134 80.7471 46.0283C80.871 46.3452 80.9262 46.779 80.8232 47.3799C80.7155 47.9826 80.5157 48.3713 80.292 48.625C80.07 48.8766 79.7978 49.0262 79.4941 49.1094C78.8635 49.282 78.1429 49.1621 77.5752 49.0615L60.0156 44.085L59.9912 44.0781L59.9668 44.0732L59.7178 44.0156C59.3991 43.9314 58.8774 43.7714 58.2236 43.5596C57.37 43.283 56.333 42.9316 55.3281 42.5859C55.3082 42.5791 55.2884 42.5713 55.2686 42.5645L78.3457 44.6689Z",
    fill: "url(#paint12_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6133 30.9551C76.1855 30.8628 76.904 30.748 77.5352 30.9229C77.8394 31.0072 78.1118 31.157 78.334 31.4092C78.5578 31.6633 78.7575 32.0517 78.8652 32.6543C78.9728 33.2562 78.919 33.6895 78.7959 34.0059C78.6736 34.3202 78.4686 34.5564 78.21 34.7412C77.6772 35.122 76.9598 35.2618 76.3955 35.3623L60.3008 36.6973L60.2773 36.6992L60.2549 36.7031C60.0221 36.7444 59.3595 36.7831 58.4434 36.8145C57.5466 36.8452 56.4514 36.8681 55.3887 36.8848C55.0115 36.8907 54.6385 36.893 54.2803 36.8975C54.6191 36.7789 54.9718 36.654 55.3291 36.5303C56.3339 36.1824 57.371 35.8289 58.2246 35.5508C59.0965 35.2667 59.7334 35.0766 59.9668 35.0352L59.9863 35.0312L60.0049 35.0264L75.6133 30.9551Z",
    fill: "url(#paint13_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5244 19.2324C70.8393 19.2076 71.1455 19.2559 71.4385 19.417C71.7335 19.5793 72.0514 19.8759 72.3545 20.4062L72.3555 20.4092C72.6628 20.9401 72.761 21.3673 72.7539 21.707C72.7467 22.0441 72.6349 22.3344 72.4561 22.5947C72.0866 23.1325 71.459 23.5068 70.9609 23.7881L58.0537 29.6387L58.0283 29.6494L58.0049 29.6631C57.8046 29.7818 57.1987 30.0458 56.3477 30.3906C55.5159 30.7276 54.4946 31.1248 53.501 31.5049C53.1487 31.6397 52.7989 31.7696 52.4639 31.8965C52.7407 31.6702 53.028 31.4335 53.3203 31.1963C54.1462 30.526 55.0009 29.8401 55.709 29.2881C56.4331 28.7236 56.9653 28.3302 57.1699 28.2148L57.1934 28.2012L57.2158 28.1855L68.7285 19.9229C69.2341 19.638 69.8725 19.2838 70.5244 19.2324Z",
    fill: "url(#paint14_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6768 9.74512C61.9641 9.61388 62.2704 9.5534 62.6045 9.60352C62.8989 9.64772 63.2452 9.78215 63.6426 10.0771L63.8154 10.2139C64.2798 10.6076 64.515 10.9745 64.623 11.2959C64.7306 11.616 64.7245 11.9281 64.6455 12.2344C64.4822 12.8674 64.0236 13.4313 63.6582 13.8701L53.5293 23.7871L53.5137 23.8027L53.499 23.8193C53.3428 24.0021 52.8567 24.46 52.1748 25.0732C51.5061 25.6746 50.6807 26.3976 49.877 27.0957C49.596 27.3398 49.3157 27.5783 49.0479 27.8096C49.2291 27.5047 49.4168 27.1872 49.6084 26.8672C50.1553 25.9534 50.7232 25.0144 51.1982 24.252C51.6832 23.4736 52.0474 22.9184 52.1982 22.7373L52.2129 22.7188L52.2266 22.6992L60.2422 11.0039C60.6068 10.5668 61.0827 10.0165 61.6768 9.74512Z",
    fill: "url(#paint15_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9414 3.39941C51.2725 3.3337 51.7078 3.35699 52.2822 3.56836L52.2852 3.56934C52.8593 3.77665 53.2069 4.0397 53.4189 4.30371C53.6295 4.56599 53.7316 4.8604 53.7627 5.17578C53.827 5.82809 53.5894 6.51876 53.3975 7.05859L47.2686 19.833L47.2588 19.8535L47.251 19.875C47.1672 20.0995 46.8669 20.6949 46.4365 21.5039C46.0146 22.2972 45.4875 23.259 44.9717 24.1895C44.7924 24.5128 44.6118 24.8306 44.4404 25.1377C44.5058 24.7929 44.5728 24.4344 44.6426 24.0723C44.8438 23.0285 45.056 21.9541 45.2412 21.0762C45.4303 20.18 45.5826 19.532 45.6621 19.3086L45.6699 19.2871L45.6748 19.2656L49.1914 5.53223C49.3936 4.99015 49.6551 4.30735 50.1221 3.84766C50.3474 3.62592 50.6127 3.46471 50.9414 3.39941Z",
    fill: "url(#paint16_linear_2153_19162)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9805 32.2275C28.5324 35.6939 28.7014 39.3461 30.1602 42.207V42.208C31.8412 45.6261 35.2584 47.8154 38.8037 48.0049V48.0059C42.3816 48.2306 46.0095 46.5087 48.1035 43.293L48.1025 43.292C49.889 40.6536 50.5306 37.0402 49.5225 33.4268C50.4758 34.5862 51.1888 36.0194 51.5586 37.5771V37.5781C52.0871 39.8629 51.8996 42.4407 50.8945 44.7236L50.8896 44.7334C49.9345 47.036 48.1906 49.0567 45.9805 50.4102L45.9795 50.4111C43.7897 51.7626 41.151 52.4144 38.5654 52.2432L38.5322 52.7412L38.5654 52.2422H38.5586C35.9587 52.1053 33.406 51.1119 31.4033 49.5029L31.4014 49.501L31.0312 49.1953C29.212 47.6292 27.8508 45.5318 27.2275 43.2783L27.2266 43.2754C26.5412 40.8596 26.6136 38.3169 27.4453 36.1104L27.4463 36.1055C28 34.5944 28.8892 33.2603 29.9805 32.2275Z",
    fill: "url(#paint17_linear_2153_19162)",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2153_19162",
    x1: 86.1535,
    y1: 44.7471,
    x2: 27.2814,
    y2: 103.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2153_19162",
    x1: 95.5348,
    y1: 5.97835,
    x2: 60.3486,
    y2: 81.4354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2153_19162",
    x1: 83.1615,
    y1: -39.9607,
    x2: 75.9051,
    y2: 42.9802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2153_19162",
    x1: 45.6978,
    y1: -78.6225,
    x2: 67.2465,
    y2: 1.79821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2153_19162",
    x1: -10.313,
    y1: -94.3589,
    x2: 37.4416,
    y2: -26.1582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2153_19162",
    x1: -97.581,
    y1: -53.5018,
    x2: -21.5864,
    y2: -13.9697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2153_19162",
    x1: -138.785,
    y1: 24.4954,
    x2: -54.5356,
    y2: 20.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2153_19162",
    x1: -131.662,
    y1: 56.7558,
    x2: -57.8178,
    y2: 22.3217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2153_19162",
    x1: -149.698,
    y1: 47.732,
    x2: -93.984,
    y2: -7.98234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2153_19162",
    x1: -107.933,
    y1: 99.9193,
    x2: -74.3285,
    y2: 27.8534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2153_19162",
    x1: -45.3846,
    y1: 123.178,
    x2: -38.3415,
    y2: 42.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2153_19162",
    x1: -4.84791,
    y1: 115.549,
    x2: -25.5179,
    y2: 38.4077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2153_19162",
    x1: 17.5498,
    y1: 99.6528,
    x2: -28.7323,
    y2: 33.5551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2153_19162",
    x1: 27.9029,
    y1: 85.3187,
    x2: -39.5071,
    y2: 38.1178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2153_19162",
    x1: 34.7327,
    y1: 76.5456,
    x2: -45.6879,
    y2: 54.9969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2153_19162",
    x1: 45.8688,
    y1: 75.9921,
    x2: -37.0721,
    y2: 83.2486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2153_19162",
    x1: 65.5671,
    y1: 67.9476,
    x2: -9.88995,
    y2: 103.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2153_19162",
    x1: 77.4231,
    y1: 24.1384,
    x2: 7.58381,
    y2: 93.9777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1C24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArkanLogoSectiom);
export default __webpack_public_path__ + "static/media/arkan-logo-sectiom.f453ebf259ff54c3650a99e8e91f5eee.svg";
export { ForwardRef as ReactComponent };